import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import Chart from 'react-apexcharts';
import { DocumentPanelContainer, RecordContainter } from './styles';
import { Link } from 'react-router-dom';
import { Button, message, Card, Avatar, Icon, Tooltip, Popconfirm, Divider } from 'antd';
import SearchSelectObject from '../../../../components/ReusableComponents/SearchSelectObject';
import { SEARCHABLE_TABLE, STATUS_MONITORING, DOCUMENT_PANEL as trans } from '../TranslationValues';
import { withTranslation } from 'react-i18next';
import { PrintingModal } from '../../../../utils/complexDocumentConstants';
import { formatDataForApexBarChart, transformMetaSearchFilter, transformMetaSearchKeys, transformRemovedTagFilters, getChannelTotals,mergeFields, removeInvisibleCharacters } from '../../../../utils/helper';
import { getAllLanguage } from '../../../../utils/services/languageApi';
import { channels, getStatusByContentType, metaSearchKeyMappings, stageStatus } from '../../../../utils/constants/statusMonitoring';
import { getSearchMetaKeys, postExclusions, getExclusions, fetchExclusionsData,getJobRecords, postHybridExclusions, getHybridExclusions, revertHybridExclusions} from '../../../../utils/services/statusMonitoringAPI';
import { getUser } from '../../../../utils/services/userAPI';
import moment from 'moment';
import { getHybridBatchList } from '../../../../utils/services/hybridMailAPI';
import { getHybridPayloadStatusKeyMap } from '../../../../utils/helper';

const namespaces = ['SEARCHABLE_TABLE', 'DOCUMENT_PANEL'];

const defaultPrintSearchStatus = [
  { fieldName: 'status', value: 'success' },
  {
    fieldName: 'channel',
    value: 'print',
  },
];

const defaultEmailSearchStatus = [
  {
    fieldName: 'status',
    value: 'generated',
  },
  {
    fieldName: 'channel',
    value: 'email',
  },
];

const DocumentPanel = ({ jobId, activeItem, t, contentType, setStatsFilter, chartRef, barChartRef,totalStats, setRemovedRecord, setFailureRecord,  staticStatsKeys=[], statsKeys = [], statsFilter, setExclusionHistory, reloadSync, setReloadSync, activeChannel }) => {
  const isHybrid = activeItem?.batchType.toLowerCase() === 'hybrid';
  const [languageList, setLanguageList] = useState([]);
  const keyNames = metaSearchKeyMappings(t);
  const {barChartData, categories} = formatDataForApexBarChart(JSON.parse(activeItem?.languageStats)?.print || [], t, languageList, contentType);
  const [searchMetaKeys, setSearchMetaKeys] = useState([]);
  const toggleDataPointPreventRerenderRef = useRef(false);
  const [valueDataSet, setValueDataSet] = useState({
    [metaSearchKeyMappings(t).channel]: channels(t),
    [metaSearchKeyMappings(t).status]: stageStatus(t),
  });
  const [metaKeyRefs, setMetaKeyRefs] = useState({});
  const [removedTags, setRemovedTags] = useState([]);
  const [users, setUsers] = useState([]);
  const allowValuesforKeys = [
    metaSearchKeyMappings(t).channel,
    metaSearchKeyMappings(t).language,
    metaSearchKeyMappings(t).status,
  ];
  const batchStats = activeItem?.batchStats || [];
  const channelTotals = useMemo(() => getChannelTotals(batchStats, false, t, true) , [batchStats, t]);
  const [exclusionAudit, setExclusionAudit] = useState([]);
  const [removedRecordsCount, setRemovedRecordsCount] = useState(0);
  const [exclusionCount, setExclusionCount] = useState(0);
  const [exclusionFilters, setExclusionFilters] = useState([]);
  const [hybridExcludedList, setHybridExcludedList] = useState([]);

  const stateRef = React.useRef(statsFilter);
  useEffect(() => {
    stateRef.current = statsFilter;
  }, [statsFilter]);

  const chartData = {
    series: [totalStats.success, totalStats.failure],
    options: {
      labels: stageStatus(t).map(status => status.key),
      colors: ['#C8E066', '#35346A', '#6CE5E8',],
      plotOptions: {
        pie: {
          expandOnClick: false,
          donut: {
            size: '50%',
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: true,
        position: 'bottom',
        horizontalAlign: 'center',
        floating: false,
        offsetY: 0,
        offsetX: 0,
        formatter: function(val, opts) {
          console.log({ val, opts });
          return (
            '<span style="font-family: Lato"><strong>' +
            val +
            ': ' +
            opts.w.globals.series[opts.seriesIndex] +
            '</strong></span>'
          );
        },
      },
      tooltip: {
        enabled: false,
      },
      chart: {
        events: {
          dataPointSelection: function(event, chartContext, opts) {
            let updatedList = [...stateRef.current];
            const labels = opts.w.config.labels;
            const dataPointIndex = opts.dataPointIndex;

            if (!updatedList.some(item => item.value === labels[dataPointIndex])) {
              updatedList.push({
                key: keyNames.status,
                value: labels[dataPointIndex],
              });
            } else {
              updatedList = updatedList.filter(item => item.value !== labels[dataPointIndex]);
            }
            setStatsFilter(updatedList);
          },
        },
      },
      states: {
        active: {
          allowMultipleDataPointsSelection: true,
          filter: {
            type: 'darken',
          },
        },
      },
    },
  };

  const BarData = {
    options: {
      chart: {
        type: 'bar',
        events: {
          dataPointSelection: (event, chartContext, config) => {
            if (!toggleDataPointPreventRerenderRef.current) {
              toggleDataPointPreventRerenderRef.current = true;
              const seriesIndex = config.seriesIndex;
              const dataPointIndex = config.dataPointIndex;
              const selectedLabel = config.w.globals.labels[dataPointIndex];

              let updatedList = [...stateRef.current];

              if (!updatedList.some(item => item.value === selectedLabel)) {
                updatedList.push({ key: keyNames.language, value: selectedLabel,seriesIndex:seriesIndex });
              } else {
                updatedList = updatedList.filter(item => item.value !== selectedLabel);
              }

              stateRef.current = updatedList;
              setStatsFilter(stateRef.current);
              chartContext.toggleDataPointSelection(seriesIndex === 0 ? 1 : 0, dataPointIndex);
            } else {
              toggleDataPointPreventRerenderRef.current = false;
            }
          },
        },
        toolbar: {
          show: false,
          tools: {
            download: false,
          },
          export: {},
        },
      },
      colors: ['#C8E066', '#35346A'],
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            position: 'top',
          },
        },
      },
      dataLabels: {
        enabled: false,
        offsetX: -6,
        style: {
          fontSize: '12px',
          colors: ['#000'],
        },
        formatter: function(val) {
          if (val >= 1000000) {
            // more than one million
            return (val / 1000000).toFixed(1) + 'M';
          } else if (val >= 1000) {
            // more than one thousands
            return (val / 1000).toFixed(1) + 'k';
          } else {
            return val;
          }
        },
      },
      stroke: {
        show: true,
        width: 1,
        colors: ['#fff'],
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter: function(val, { series, seriesIndex, dataPointIndex, w }) {
            if (val >= 1000000) {
              // more than one millions
              return (val / 1000000).toFixed(1) + 'M';
            } else if (val >= 1000) {
              // more than one thousands
              return (val / 1000).toFixed(1) + 'k';
            } else if (val < 1000) {
              // more than one thousands
              return val.toFixed(0);
            } else {
              return val;
            }
          },
        },
      },
      xaxis: {
        categories: categories,
        labels: {
          formatter: function(val) {
            if (val >= 1000000) {
              // more than one millions
              return (val / 1000000).toFixed(1) + 'M';
            } else if (val >= 1000) {
              // more than one thousands
              return (val / 1000).toFixed(1) + 'k';
            } else {
              return Math.round(val * 10)/10;
            }
          },
        },
      },
      legend: {
        onItemClick: {
          toggleDataSeries: false,
        },
        onItemHover: {
          highlightDataSeries: false,
        },
      },
      states: {
        active: {
          allowMultipleDataPointsSelection: true,
          filter: {
            type: 'darken',
          },
        },
      },
    },
  };

  const hybridStatusValueDataSet =  {[removeInvisibleCharacters(t(SEARCHABLE_TABLE.STATUS.key, SEARCHABLE_TABLE.STATUS.value))]:getStatusByContentType(t,contentType)};

  const channelMap = {
    Documents: 'print',
    Email: 'email'
  }
  const fetchRemovedRecordsCount = useCallback(async exclusions => {
    if (!exclusions) {
      setRemovedRecordsCount(0);
      return;
    }

    const payload = {
      limit: 7,
      page: 1,
      jobId: jobId,
      search: [...defaultPrintSearchStatus],
      exclusions: exclusions,
    };
    const removedCount = await fetchExclusionsData(payload);
    removedCount && setRemovedRecordsCount(removedCount?.dataCount);
  });

  const handleRemoveTags = async (type, id = null) => {
    if ((type === "removed" && !removedTags.length) || (type === "included" && !id)) return;
    let payload;  
    if (isHybrid) {
      if(type === 'included'){
        const jobRevertRes = await revertHybridExclusions(id);
        if(jobRevertRes && jobRevertRes?.statusCode === 7034){
          message.success(t(trans.RECORDS_REVERTED_SUCCESS.key, trans.RECORDS_REVERTED_SUCCESS.value));
          fetchExclusionCount();
          fetchHybridExclusions(users);
          document.dispatchEvent(new CustomEvent('updateHybridBatchList'));
        }
        else{
          message.error(t(trans.INCLUSION_FAILED.key, trans.INCLUSION_FAILED.value));
        }
      }
      else{
      const result = removedTags.reduce((acc, item) => {
        if (item.key.toLowerCase() === 'status') {
          acc.status = getHybridPayloadStatusKeyMap[item.value];
        }
        if (item.key.toLowerCase() === 'address') {
          acc.text = item.value;
        }
        return acc;
      }, {});
       payload = {
        batchId: jobId,
        ...(result.status && { status: result.status }),
        ...(result.text && { text: result.text }),
      }
    }
    }

    else{
      const tagsRemoved =
        type === "removed" && removedTags.length
          ? transformMetaSearchFilter(removedTags, metaKeyRefs, valueDataSet)
          : [];

      payload = {
        jobId,
        exclusionAudit: [
          {
            ...(type === "removed" && { exclusion: tagsRemoved }),
            ...(type === "included" && id && { reference: id }),
            type,
          },
        ],
        channel: channelMap[activeChannel],
      };
    }

    try {
      if(isHybrid && type !== 'included'){
        const exclusionResponse = await postHybridExclusions(payload);
        if( exclusionResponse && exclusionResponse?.statusCode === 7032){        
          message.success(t(trans.RECORDS_REMOVED_SUCCESS.key, trans.RECORDS_REMOVED_SUCCESS.value));
          fetchHybridExclusions(users);
          fetchExclusionCount();
          document.dispatchEvent(new CustomEvent('updateHybridBatchList'));
        }
        else{
          message.error(t(trans.EXCLUSION_FAILED.key, trans.EXCLUSION_FAILED.value));
        }
      }
      else{
      const res = await postExclusions(payload);
      if (res.statusCode === 5109 && res.data) {
        setExclusionAudit(
          transformRemovedTagFilters(res.data.exclusionAudit, valueDataSet, users, t)
        );
        setExclusionHistory(res.data.exclusions);
        setExclusionFilters(res.data.exclusions)
        message.success(type === "included"
          ? t(trans.RECORDS_REVERTED_SUCCESS.key, trans.RECORDS_REVERTED_SUCCESS.value)
          : t(trans.RECORDS_REMOVED_SUCCESS.key, trans.RECORDS_REMOVED_SUCCESS.value));
      };
      fetchRemovedRecordsCount(res.data.exclusions);
    }
    } catch (error) {
      console.error("Error removing tags:", error);
    }
  
    setRemovedTags([]);
  };

  const transformToFlatList = (data, usersList) => {
    const userMap = Object.fromEntries(usersList.map(({ id, displayName }) => [id, displayName]));

    return data.flatMap((item) => {
      const updated = { ...item };

      if (updated.filterParams) {
        const parsed = JSON.parse(updated.filterParams);
        delete parsed.hybridBatchId;
        updated.filterParams = JSON.stringify(parsed);
      }

      ['excludedBy', 'revertedBy'].forEach((field) => {
        if (updated[field]) {
          updated[field] = userMap[Number(updated[field])] || updated[field];
        }
      });

      const entries = [];
      const showRevertButton = !updated.revertedBy;

      if (updated.excludedBy) {
        entries.push({
          ...updated,
          actionType: 'excluded',
          actionBy: updated.excludedBy,
          actionAt: updated.excludedAt,
          showRevertButton,
        });
      }

      if (updated.reverted && updated.revertedBy) {
        entries.push({
          ...updated,
          actionType: 'included',
          actionBy: updated.revertedBy,
          actionAt: updated.revertedAt,
          showRevertButton: false,
        });
      }

      return entries;
    });
  };

  const processHybridExclusions = (data, usersList) => {
    const transformedData = transformToFlatList(data, usersList);
    setHybridExcludedList(transformedData);
    setReloadSync(false);
  };

  const fetchHybridExclusions = async () => {
    try {
      const hybridExclusions = await getHybridExclusions(jobId);
      if (hybridExclusions?.statusCode === 7032) {
        processHybridExclusions(hybridExclusions.data, users);
      }
    } catch {
      console.error("Error fetching hybrid batch infos:");
    }
  };

  const fetchExclusionCount = async () => {
    const res = await getHybridBatchList({
      hybridBatchId: jobId,
      page: 1,
      limit: 1,
      desc: false,
      status: '',
      text: '',
      exclusionFilter: 'ONLY_EXCLUDED',
    });
    if (res?.statusCode === 7014) {
      setRemovedRecordsCount(res?.dataCount ? res.dataCount : 0);
    }

  }

  useEffect(() => {
    if (!jobId) return;
    const fetchAllHybridBatchInfos = async () => {
      try {
        const [users, hybridExclusionsResponse] = await Promise.all([getUser(), fetchHybridExclusions(),fetchExclusionCount()]);
        let usersList;
        if (users.statusCode === 823) {
          setUsers(users.data);
          usersList = users.data;
        }
        if (hybridExclusionsResponse && hybridExclusionsResponse?.statusCode === 7032) {
          processHybridExclusions(hybridExclusionsResponse.data, usersList);
        }
        setReloadSync(false);
      } catch (error) {
        console.error("Error fetching hybrid batch infos:", error);
      }
    };
    const fetchAllInfos = async () => {
      try {
        const [metaSearchKeys, users, allLanguages, exclusions] = await Promise.all([
          getSearchMetaKeys(jobId),
          getUser(),
          getAllLanguage(),
          getExclusions(jobId, channelMap[activeChannel]),
        ]);

        let valueMappingDataSet, usersList;

        if (metaSearchKeys.statusCode === 5002) {
          const metaKey = metaSearchKeys.data?.length
            ? [...new Set([...staticStatsKeys, ...metaSearchKeys.data])]
            : staticStatsKeys;
          const { transformedKeys, referenceKeysObject } = transformMetaSearchKeys(metaKey, t);
          setSearchMetaKeys(transformedKeys);
          setMetaKeyRefs(referenceKeysObject);
        }

        if (users.statusCode === 823) {
          setUsers(users.data);
          usersList = users.data;
        }

        if (allLanguages.statusCode === 109 && allLanguages.data) {
          const lang = allLanguages.data.map(({ name, code }) => ({ key: name, value: code }));
          valueMappingDataSet = { ...valueDataSet, [metaSearchKeyMappings(t).language]: lang };
          setValueDataSet(prev => ({ ...prev, [metaSearchKeyMappings(t).language]: lang }));
          setLanguageList(lang);
        }

        if (exclusions.statusCode === 5108 && exclusions.data.exclusionAudit.length) {
          setExclusionAudit(transformRemovedTagFilters(exclusions.data.exclusionAudit, valueMappingDataSet, usersList, t));
          setExclusionHistory(exclusions.data.exclusions);
          setExclusionFilters(exclusions.data.exclusions)
          exclusions.data.exclusions.length && await fetchRemovedRecordsCount(exclusions.data.exclusions);
        };
        setReloadSync(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    const fetchLanguages = async () => {
      try {
        const res = await getAllLanguage();
        if (res.statusCode === 109) {
          setLanguageList(res.data.map(({ name, code }) => ({ key: name, value: code })));
        }
      } catch (error) {
        console.error("Error fetching languages:", error);
      }
    };
    !isHybrid && contentType === PrintingModal && reloadSync ? fetchAllInfos() : fetchLanguages();
    isHybrid && contentType === PrintingModal && fetchAllHybridBatchInfos();
  }, [jobId, contentType, reloadSync,]);

  useEffect(() =>{ 
    return () =>{
      setReloadSync(true);
    }
  },[setReloadSync])

  const handlePopupVisibleChange = async()=>{
    if(!removedTags.length) return;
    let countResponse;
    if (isHybrid) {
      const result = removedTags.reduce((acc, item) => {
        if (item.key.toLowerCase() === 'status') {
          acc.status = getHybridPayloadStatusKeyMap[item.value];
        }
        if (item.key.toLowerCase() === 'address') {
          acc.text = item.value;
        }
        return acc;
      }, {});      
      const payload = {
      hybridBatchId: jobId,
      page: 1,
      limit: 1,
      desc: false,
      ...(result.status &&{ status: result.status}),
      ...(result.text && { text: result.text }),
    }  
      countResponse = await getHybridBatchList(payload);
    }
    else{
    const searchValue = [
      ...(activeChannel === 'Documents' ? defaultPrintSearchStatus : defaultEmailSearchStatus),
      ...transformMetaSearchFilter(removedTags, metaKeyRefs, valueDataSet),
    ];
    const payload = {
      limit: 7,
      page: 1,
      jobId: jobId,
      search: searchValue,
      exclusions: exclusionFilters,
    };

     countResponse = await getJobRecords(payload);
  }
    countResponse && setExclusionCount(countResponse?.dataCount);
  };

  useEffect(() => {
    if (isHybrid) {
      const selectedKeySet = new Set(removedTags.map(({ key }) => key.toLowerCase()));
      setSearchMetaKeys(staticStatsKeys.filter(key => !selectedKeySet.has(key)));
    }
  }, [removedTags]);
  
  return (
    <>
    { 
    (channelTotals.print > 0 || (contentType === PrintingModal && channelTotals.email > 0) || channelTotals.hybrid > 0) ? ( <DocumentPanelContainer disablePopConfirmButton={exclusionCount===0}>
      {contentType === PrintingModal && (
        <div className="filter-container">
          <p style={{ fontSize: '14px', fontWeight: 400 }}>
            {activeChannel === 'Documents' ? 
              t(trans.SEARCH_REMOVED_DOCUMENTS.key, trans.SEARCH_REMOVED_DOCUMENTS.value)
              : t(trans.SEARCH_FOR_EMAILS_TO_REMOVE.key, trans.SEARCH_FOR_EMAILS_TO_REMOVE.value)}
          </p>
          <p>
            <Link
            // disabled={removedRecordsCount === 0}
              onClick={() => {
                setFailureRecord(false);
                setRemovedRecord(true);
              }}
            >
              {t(trans.VIEW_REMOVED_RECORDS.key, trans.VIEW_REMOVED_RECORDS.value)}
            </Link>{' '}
            <span className="italic-font">
               {removedRecordsCount} {t(trans.REMOVED_RECORDS_COUNT.key, trans.REMOVED_RECORDS_COUNT.value)}
            </span>
          </p>
          <SearchSelectObject
            keyDataSet={searchMetaKeys}
            placeholder={t(
              SEARCHABLE_TABLE.SEARCH_EXACT_METADATA_PLACEHOLDER.key,
              SEARCHABLE_TABLE.SEARCH_EXACT_METADATA_PLACEHOLDER.value,
            )}
            showSelectedKeys={false}
            isDynamicKeyValue={true}
            selectedFilters={removedTags}
            setSelectedFilters={setRemovedTags}
            statsKeys={statsKeys}
            valueDataSet={isHybrid ? hybridStatusValueDataSet: valueDataSet}
            allowValuesforKeys={allowValuesforKeys}
            fullWidth={true}
          />
             <Popconfirm
                title={t(trans.REMOVED_CONFIRM_TITLE.key, trans.REMOVED_CONFIRM_TITLE.value, { count: exclusionCount })}
                okText={t(trans.YES.key, trans.YES.value)}
                cancelText={t(trans.CANCEL.key, trans.CANCEL.value)}
                placement="left"
                trigger="click"                
                okButtonProps={{ style: { display: exclusionCount === 0 ? 'none' : '' } }}    
                onConfirm={() => {
                  handleRemoveTags('removed');
                  setExclusionCount(0);
                }}
                onVisibleChange={handlePopupVisibleChange}                
                overlayStyle={{ width: 350 }}
                disabled={!removedTags.length}
              >
                <Button className="filter-button">
                  {t(trans.REMOVE_FROM_JOB.key, trans.REMOVE_FROM_JOB.value)}
                </Button>
              </Popconfirm>
              <RecordContainter>
                  {isHybrid ?
                  [...hybridExcludedList].reverse().map(({ id, filterParams, actionType, actionBy, actionAt, showRevertButton }, i) => {
                    const parsedFilters = JSON.parse(filterParams);
                    return (
                      <Card key={`${id}-${actionType}-${i}`} className="animate" hoverable={false} style={{ position: "relative" }}>
                        <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                          {Object.entries(parsedFilters)
                            .filter(([, value]) => value !== null)
                            .map(([key, value]) => (
                              <div key={`${key}-${value}`} className="filtered-key">
                                {key === 'text' ? 'Address' : key} : {Array.isArray(value) ? value.join(", ") : value}
                              </div>
                            ))}

                          <span className="card-bottom">
                            <span className="removed-info">
                              {actionType === 'included' ? (
                                <>
                                  {t(trans.INCLUDED.key, trans.INCLUDED.value)} {t(trans.BY_LABEL.key, trans.BY_LABEL.value)} {actionBy}{" "}
                                  {t(trans.ON_LABEL.key, trans.ON_LABEL.value)}{" "}
                                  {moment(actionAt).format("YYYY-MM-DD HH:mm")}
                                </>
                              ) : (
                                <>
                                   {t(trans.REMOVED.key, trans.REMOVED.value)} {t(trans.BY_LABEL.key, trans.BY_LABEL.value)} {actionBy}{" "}
                                  {t(trans.ON_LABEL.key, trans.ON_LABEL.value)}{" "}
                                  {moment(actionAt).format("YYYY-MM-DD HH:mm")}
                                </>
                              )}
                            </span>
                            {showRevertButton && (
                              <Tooltip title={t(trans.REVERT_TOOLTIP.key, trans.REVERT_TOOLTIP.value)}>
                                <Popconfirm
                                  title={t(trans.REVERT_CONFIRM_TITLE.key, trans.REVERT_CONFIRM_TITLE.value)}
                                  okText={t(trans.YES.key, trans.YES.value)}
                                  cancelText={t(trans.CANCEL.key, trans.CANCEL.value)}
                                  placement="left"
                                  trigger="click"
                                  onConfirm={() => handleRemoveTags('included', id)}
                                  overlayStyle={{ width: 350 }}
                                >
                                  <span className="roll-back">
                                    <Icon type="rollback" /> {t(trans.REVERT_LABEL.key, trans.REVERT_LABEL.value)}
                                  </span>
                                </Popconfirm>
                              </Tooltip>
                            )}
                          </span>
                        </div>
                      </Card>
                    );
                  })
                    :
                    [...exclusionAudit].reverse().map(({ exclusion, type, doneBy, doneOn, isRemovedIncluded, id }, i) => (
                      <Card key={i} className="animate" hoverable={false} style={{ position: "relative" }}>
                        <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                          {exclusion.map(({ key, value }) => (
                            <div key={`${key}-${value}`} className="filtered-key">
                              {key} : {value}
                            </div>
                          ))}

                          <span className="card-bottom">
                            <span className="removed-info">
                              {type} {t(trans.BY_LABEL.key, trans.BY_LABEL.value)} {doneBy} {t(trans.ON_LABEL.key, trans.ON_LABEL.value)} {moment(doneOn).format("YYYY-MM-DD HH:mm")}
                            </span>

                            {!isRemovedIncluded && (
                              <Tooltip title={t(trans.REVERT_TOOLTIP.key, trans.REVERT_TOOLTIP.value)}>
                                <Popconfirm
                                  title={t(trans.REVERT_CONFIRM_TITLE.key, trans.REVERT_CONFIRM_TITLE.value)}
                                  okText={t(trans.YES.key, trans.YES.value)}
                                  cancelText={t(trans.CANCEL.key, trans.CANCEL.value)}
                                  placement="left"
                                  trigger="click"
                                  onConfirm={() => handleRemoveTags('included', id)}
                                  overlayStyle={{ width: 350 }}
                                >
                                  <span className="roll-back">
                                    <Icon type="rollback" /> {t(trans.REVERT_LABEL.key, trans.REVERT_LABEL.value)}
                                  </span>
                                </Popconfirm>
                              </Tooltip>
                            )}
                          </span>
                        </div>
                      </Card>
                    ))
                  }
              </RecordContainter>
          <Divider style={{margin:'5px 0'}}/>
         { !isHybrid && <p>
            <Link
              onClick={() => {
                setRemovedRecord(false);
                setFailureRecord(true);
              }}
            >
              {t(trans.VIEW_FAILURE_RECORDS.key, trans.VIEW_FAILURE_RECORDS.value)}
            </Link>
          </p>}
        </div>
      )}
      {contentType !== PrintingModal && <><div className="chart-wrapper">
          <p className="chart-title">{t(trans.FAILURE_STATS.key, trans.FAILURE_STATS.value)}</p>
          <Chart
            ref={chartRef}
            type="donut"
            options={activeItem ? chartData.options : {}}
            series={activeItem ? chartData.series : []}
            width={'100%'}
          />
        </div>
        <div className="chart-wrapper">
          <div className='chart-container'>
            <p className="chart-title">{t(trans.LANGUAGES_STATS.key, trans.LANGUAGES_STATS.value)}</p>
            <Chart
              type="bar"
              ref={barChartRef}
              options={activeItem ? BarData.options : {}}
              series={activeItem ? barChartData : []}
              width={'100%'}
              height={categories.length > 3 ? 50 * categories.length :  undefined}
            />
          </div>
        </div></>}
      </DocumentPanelContainer>)
      : <h5>{t(STATUS_MONITORING.NO_RECORDS_FOUND.key, STATUS_MONITORING.NO_RECORDS_FOUND.value)}</h5>}
    </>
  );
};

export default withTranslation(namespaces)(DocumentPanel);
